import { useParams } from 'react-router';

export const useRequiredParams = <K extends string>(
  keys: readonly K[],
): Record<K, string> => {
  const params = useParams();

  for (const key of keys) {
    if (params[key] === undefined) {
      throw new Error(`Missing required route param: "${key}"`);
    }
  }

  return params as Record<K, string>;
};
